import React from 'react';
import { Title, TitleProps } from '@soluto-design/react';
import cls from '@soluto-design/styles/cls';

export interface AwardsSectionProps {
    title?: string;
    titleTag?: TitleProps['component'];
    awards: {
        icon?: string;
        title: string;
        link: string;
    }[];
}

function AwardsSection({ awards, title, titleTag = 'h2' }: AwardsSectionProps) {
    return (
        <section className="my-mega">
            <div className="container">
                {!!title && (
                    <Title
                        component={titleTag}
                        className="text-h300 text-text-primary">
                        {title}
                    </Title>
                )}
                {awards && awards.length > 0 && (
                    <div
                        className={cls(
                            'pt-xl flex flex-col lg:grid gap-gutter',
                            awards.length < 5 ||
                                (awards.length > 5 && awards.length < 9)
                                ? 'lg:grid-cols-4'
                                : 'lg:grid-cols-5',
                        )}>
                        {awards.map(({ icon, title, link }, i) => {
                            return (
                                <a
                                    key={`award-${i}`}
                                    href={link}
                                    target="_blank"
                                    rel="noreferrer"
                                    className=" py-24 px-8 bg-background-secondary rounded-large text-center !no-underline !font-regular text-c100">
                                    {icon ? (
                                        <div className="h-56 lg:h-64 xl:h-72 w-auto flex justify-center mb-16">
                                            <img
                                                src={icon}
                                                alt={title}
                                                className="h-full w-auto"
                                            />
                                        </div>
                                    ) : null}
                                    {title}
                                </a>
                            );
                        })}
                    </div>
                )}
            </div>
        </section>
    );
}

export default AwardsSection;
